import { locationSearchFormStyles as styles } from "@insite/content-library/Components/LocationSearchForm";
import { RadioStyle } from "@insite/mobius/Radio";
import { commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide";
import { css } from "styled-components";

const commonLocationLinksStyles = {
    css: css`
        ${customLinkHoverStyles}
    `,
    mergeCss: true,
};

styles.searchInputGridContainer = {
    gap: 5,
    offsetCss: css`
        justify-content: space-between;
        row-gap: 5px;
    `,
};

styles.searchResultsTextGridItem = {
    width: 6,
    css: css`
        display: flex;
        align-items: center;
        margin: 0;
    `,
};

styles.distanceUnitOfMeasureGridItem = {
    width: 6,
    align: "middle",
    css: css`
        ${RadioStyle} {
            & + ${RadioStyle} {
                margin-top: 0;
            }
        }
    `,
};

styles.searchResultDisplayNumberGridItem = {
    ...styles.searchResultDisplayNumberGridItem,
    css: css`
        display: flex;
        align-items: center;
        margin: 0;
    `,
};

styles.locationNameLink = {
    ...styles.locationNameLink,
    ...commonLocationLinksStyles,
};

styles.searchResultPhoneLink = {
    ...styles.searchResultPhoneLink,
    ...commonLocationLinksStyles,
};

styles.locationContentLink = {
    ...styles.locationContentLink,
    ...commonLocationLinksStyles,
};

styles.locationGoogleMapsDirectionLink = {
    ...styles.locationGoogleMapsDirectionLink,
    ...commonLocationLinksStyles,
};

styles.searchResultDistanceGridItem = {
    ...styles.searchResultDistanceGridItem,
    css: css`
        align-items: flex-end;
    `,
};

styles.searchResultGoogleMapsDirectionLinkGridItem = {
    ...styles.searchResultGoogleMapsDirectionLinkGridItem,
    width: [3, 3, 3, 3, 2],
};

styles.searchResultDistanceGridItem = {
    ...styles.searchResultDistanceGridItem,
    width: [4, 4, 3, 3, 3],
};

styles.searchResultContentGridItem = {
    ...styles.searchResultContentGridItem,
    width: [3, 3, 3, 3, 2],
};
